import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { PageComponent } from '@shared/components';
import { ContentPageId } from '@shared/models';
import { LoggerService } from '@shared/modules/logger/logger';
import { AEMService } from '@shared/services/aem/aem.service';
import { OpenChoiceCommonContent } from '@shared/services/content/content-jsons/open-choice/open-choice-common.content';
import { OpenchoiceRemoteContent } from '@src/aem/models/OpenchoiceRemoteContent';
import * as fromRootStore from '@store/index';
import { selectClientDateOfBirth } from '@store/selectors/personal-data/personal-data.selectors';
import { combineLatest, Observable, take } from 'rxjs';
import {
  selectEmploymentStatusState,
  selectRetirementAge,
  selectTaxableIncome,
  selectTaxStatus,
  TaxableIncome,
} from 'vg-interaction-model/dist';
import { IEmploymentStatusAndDetailsState } from 'vg-interaction-model/dist/lib/features/employment/store/reducers/employment-status/employment-status.reducer';

import { toPageContent } from './tax-filing-retirement-content-mapper';

@Component({
  selector: 'app-tax-filing-retirement',
  templateUrl: './tax-filing-retirement.component.html',
  styleUrl: './tax-filing-retirement.component.scss',
})
export class TaxFilingRetirementComponent
  extends PageComponent<OpenchoiceRemoteContent>
  implements OnInit, OnDestroy
{
  openChoiceCommonContent = OpenChoiceCommonContent;
  retirementAge$: Observable<number | null>;
  birthDate$: Observable<string | null>;
  employmentStatusState$: Observable<IEmploymentStatusAndDetailsState>;
  taxStatus$: Observable<string>;
  taxableIncome$: Observable<TaxableIncome>;

  shouldTaxesErrorShow = false;
  shouldTaxableIncomeErrorShow = false;
  shouldRetirementAgeErrorShow = false;
  shouldContinueButtonSpinnerShow = false;
  employmentStatus: string | undefined;

  constructor(
    globalStore: Store<fromRootStore.State>,
    protected loggerService: LoggerService,
    protected aemService: AEMService,
  ) {
    super(ContentPageId.openchoice, globalStore, {
      aemService,
      toPageContent,
    });

    this.retirementAge$ = this.globalStore.pipe(select(selectRetirementAge));
    this.birthDate$ = this.globalStore.pipe(select(selectClientDateOfBirth));
    this.employmentStatusState$ = this.globalStore.pipe(select(selectEmploymentStatusState));
    this.taxStatus$ = this.globalStore.pipe(select(selectTaxStatus));
    this.taxableIncome$ = this.globalStore.pipe(select(selectTaxableIncome));
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.subs.add(
      this.employmentStatusState$.subscribe(
        (employmentStatusState) => (this.employmentStatus = employmentStatusState.employmentStatus),
      ),
    );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  continue() {
    this.shouldRetirementAgeErrorShow = true;
    this.shouldTaxesErrorShow = true;
    this.shouldTaxableIncomeErrorShow = true;

    combineLatest([this.retirementAge$, this.taxStatus$, this.taxableIncome$])
      .pipe(take(1))
      .subscribe(
        ([retirementAge, taxStatus, taxableIncome]: [number | null, string, TaxableIncome]) => {
          const isFormValid = retirementAge && taxStatus && taxableIncome;

          if (isFormValid) {
            this.globalStore.dispatch(fromRootStore.initializeOnboarding());
          }
        },
      );
  }
}
